import React from 'react'

import VehicleSlider from '../VehicleSlider'
import VehicleResults from '../VehicleResults'
import useVehicleCalculator from './useVehicleCalculator'

import { StyledRoot, StyledLeftSide, StyledRightSide } from '../VehicleCalculatorStyle'
import Loader from 'atoms/Loader'

const VehicleCalculator = () => {
  const {
    setSettings,
    selectedVehicleData,
    regionData,
    total_cost_saving,
    total_emissions_reduced,
    chartData,
    loading,
    diesel_vehicle,
    co2Chart,
    range_data,
  } = useVehicleCalculator()

  if (loading) return <Loader />

  return (
    <>
      <StyledRoot id="EV">
        <StyledLeftSide className={'left-class'}>
          <VehicleSlider
            setSettings={setSettings}
            selectedVehicleData={selectedVehicleData}
            regionData={regionData}
          />
        </StyledLeftSide>

        <StyledRightSide>
          <VehicleResults
            total_cost_saving={total_cost_saving}
            total_emissions_reduced={total_emissions_reduced}
            inputData={selectedVehicleData}
            diesel_vehicle={diesel_vehicle}
            chartData={chartData}
            co2Chart={co2Chart}
            range_data={range_data}
          />
        </StyledRightSide>
      </StyledRoot>
    </>
  )
}

export default VehicleCalculator
